import React, { useEffect, useState } from "react";

import { DROPDOWN_STRINGS } from "constants/constantStrings";

import Dropdown from "components/Dropdown";
import { DupontTooltip } from "components/DupontTooltip";
import ErrorLabel from "components/ErrorLabel";

const TagDropdown = props => {
  let { tagValue, tagList, onTagChange, errorMsg, requiredMsg, labelText, disabled, customClass, placeholder } = props;
  placeholder = placeholder || DROPDOWN_STRINGS.chooseOptionStr;
  const [inputError, setInputError] = useState();

  useEffect(() => {
    if (disabled) setInputError("");
  }, [disabled]);

  useEffect(() => setInputError(errorMsg), [errorMsg]);

  const getOptionLabel = ({ TagName, Units }) => getTagNameWithUnit(TagName, Units);
  const getOptionSelected = (option, value) => option.TagId === value.TagId;
  const groupBy = option => option?.Group;
  const getTagNameWithUnit = (TagName, Units) => `${TagName} [${Units}]`;
  const tagSearchLabel = ({ TagName, Units, TagId, Description }) => `${TagName} [${Units}] ${TagId} ${Description}`;

  const onInputBlur = event => {
    const { value } = event.target;
    if (requiredMsg && !value) {
      setInputError(errorMsg || requiredMsg);
    } else {
      setInputError(errorMsg);
    }
  };

  const renderOption = params => {
    const { TagName, Units, Description, TagId } = params;
    return (
      <DupontTooltip title={`${TagId} | ${Description} ` || ""} placement="bottom-start" type="primary">
        <span>{getTagNameWithUnit(TagName, Units, TagId)}</span>
      </DupontTooltip>
    );
  };

  const onValChange = (value, reason) => {
    tagValue = value;
    if (onTagChange) {
      onTagChange(value, reason);
    }
  };

  return (
    <>
      <Dropdown
        disabled={disabled}
        labelText={labelText}
        value={tagValue}
        options={tagList}
        placeholder={placeholder}
        getOptionLabel={getOptionLabel}
        getOptionSelected={getOptionSelected}
        onChange={onValChange}
        onInputBlur={onInputBlur}
        renderOption={renderOption}
        errorMsg={inputError}
        groupBy={groupBy}
        customClass={customClass}
        tagSearchLabel={tagSearchLabel}
      />
      {inputError && <ErrorLabel message={inputError} />}
    </>
  );
};

export default TagDropdown;
